import React, { PureComponent } from 'react';
import { faSignOutAlt, faUserCircle, faCog, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {APP_CONFIG} from '../../utils/config';

class SideMenu extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            //  gptYn: props.gptYn || false, //  GPT 사용 여부 state 추가
             gptMode: props.gptMode || false, //  GPT 사용 여부 state 추가
        };
        this.handleClickClose = this.handleClickClose.bind(this);
        //this.handleClickTip = this.handleClickTip.bind(this);
        this.handleClickSetting = this.handleClickSetting.bind(this);
        this.handleChangeGptYn = this.handleChangeGptYn.bind(this); // 20251017 GPT 사용유무 체크 

        //this.handleQuickMenuClick = this.handleQuickMenuClick.bind(this)
        //this.handleClickLoginAlert = this.handleClickLoginAlert.bind(this)
    }

    componentDidMount() {
        document.querySelector('.sub_menu_inner').focus()

    }

    // totalClose() {
    //     this.props.closeLoginAlert()
    //     this.props.close()
    // }

    /*
    handleQuickMenuClick(e) {
        // this.totalClose()
        this.props.close()

        let sendData = {
            "utterance" : e.target.value, 
            "sessionKey" : this.props.sessionKey,
            "channelId" : this.props.channelId,
            "isLogin" : this.props.isLogin
        }

        this.props.send(sendData)
    }
    */

    handleClickClose() {
        // this.totalClose()
        if (this.props.isLogin) {
            this.props.setSetting()
        }
        this.props.close()
    }

    /*
    handleClickTip() {
        // this.totalClose()
        this.props.close()

        let sendData = {
            "utterance" : '이용팁', 
            "sessionKey" : this.props.sessionKey,
            "channelId" : this.props.channelId,
            "isLogin" : this.props.isLogin
        }

        this.props.send(sendData)
    }
    */

    handleClickSetting() {
        if (this.props.isLogin) {// 202510
            this.props.openSetting()
        } else {
            this.props.loginAlert()
        }
    }

    /*
    handleClickLoginAlert() {
        this.props.loginAlert()
    }
    */

    clickPosition(value) {
        this.props.setMenuPostion(value)
    }



    openThemeSet() {
        const currentState = this.themeSetDiv.style.display
        //console.debug(currentState);
        if (currentState === "" || currentState === "none") {
            this.themeSetDiv.style.display = "block";
        } else {
            
            this.themeSetDiv.style.display = "none";
        }
    }
    /*
    <a href="#" className="top_menu fL"><img src="img/ico_close.png" alt="닫기" /></a>
    <a href="#" className="btn_logout left"><i className="fas fa-sign-out-alt"></i><span>로그아웃</span></a>
    <a href="#" className="btn_login left"><i className="fas fa-user-circle mR5"></i>로그인</a>
    */
componentDidUpdate(prevProps) {
    
//   if (prevProps.gptMode !== this.props.gptMode) {
//     this.setState({ gptYn: this.props.gptMode });
//   }
  if (prevProps.gptMode !== this.props.gptMode) {
    this.setState({ gptMode: this.props.gptMode });
  }


}

    /** GPT 사용 여부 변경 */
handleChangeGptYn(value) {
    if (this.props.isLogin) {  //20251028 GPT 실제 반영시 로그인이 필요하므로 추가. 
        this.setState({ gptYn: value, gptMode: value});
        // this.state.gptYn(value)
        if (this.props.setGptYn) {
            this.props.setGptYn(value); // App에 전달 → handleSetGptSetting 호출
                this.setState({ gptYn: this.props.gptMode });  // 202510 
            
        }
    } else {
        this.props.loginAlert()
    }
}
    render() {
        let topMenuClass = 'sub_menu_inner right'
        if (this.props.menuPosition === 'left') {
            topMenuClass = 'sub_menu_inner left'
        }
        let themeName = "파랑"
        if (this.props.theme === "theme_green") themeName = "초록"
        if (this.props.theme === "theme_purple") themeName = "보라"
        if (this.props.theme === "theme_red") themeName = "빨강"

        let radioStyle = {}
        if (this.props.lang === "en") radioStyle = { marginLeft:"4px"}

        return (
            <div className={topMenuClass} tabIndex={0}>
                { this.props.isLogin &&
                <a href={APP_CONFIG.logOut} className="logout_link">{this.props.uiTexts.text_27}</a>
                }
                <div className="profile_box">
                    <h2 className="sub_h_tit">{this.props.uiTexts.text_23}</h2>
                    <span className="chat_logo_box"></span>
                    { this.props.isLogin 
                        ? <span className="profile_name"><em className="point_txt">{this.props.userName}</em> {this.props.uiTexts.text_28}</span>
                        : <a href={APP_CONFIG.logIn} className="profile_name" onClick={this.handleClickLogin} ><FontAwesomeIcon icon={faUserCircle} className='mr5'/>{this.props.uiTexts.text_24}</a>
                    }
                </div>
                <ul className="sub_menu_list">
                    <li className="sub_menu_item">
                        <a href="#none" className="sub_menu_link" onClick={this.handleClickSetting}>{this.props.uiTexts.text_02}</a>
                    </li>
                    <li className="sub_menu_item">
                        <dl>
                            <dt tabIndex={0}>{this.props.uiTexts.text_03}</dt>
                            <dd>
                                <button className="inp_radio" onClick={()=>{this.clickPosition("left")}}>
                                    <input tabIndex={-1} type="radio" id="rdoCategory" name="rdo" className="inp_rdo" checked={this.props.menuPosition === "left"} onChange={()=>{this.clickPosition("left")}}/>
                                    <label htmlFor="rdoCategory" className="inp_label" >
                                        <span className="ico_comm ico_rdo"></span>
                                        {this.props.uiTexts.text_25}
                                    </label>
                                </button>
                                <button className="inp_radio" style={radioStyle} onClick={()=>{this.clickPosition("right")}}>
                                    <input tabIndex={-1} type="radio" id="rdoCategory" name="rdo" className="inp_rdo" checked={this.props.menuPosition === "right"} onChange={()=>{this.clickPosition("right")}}/>
                                    <label htmlFor="rdoCategory2" className="inp_label">
                                        <span className="ico_comm ico_rdo"></span>
                                        {this.props.uiTexts.text_26}
                                    </label>
                                </button>
                            </dd>
                        </dl>
                    </li>
                    <li className="sub_menu_item">
                        <dl>
                            <dt tabIndex={0}>{this.props.uiTexts.text_04}</dt>
                            <dd>
                                <span className="screen_out">현재 테마</span>
                                <span className="color_chip">{this.themeName}</span>
                                <button type="button" className="btn_more" onClick={()=>{this.openThemeSet()}}><span className="ico_comm ico_arrow">다른테마 더보기</span></button>
                            </dd>
                        </dl>
                        <div className="color_set" ref={(ref) => {this.themeSetDiv = ref}} >
                            
                            <button onClick={()=>{this.props.setTheme("")}} aria-label='change color blue'>
                                <input tabIndex={-1} type="radio" id="colorBlue" name="piece_txt" className="inp_blind" checked={this.props.theme === ""} onChange={()=>{this.props.setTheme("")}} />
                                <label htmlFor="colorBlue" className="inp_piece color_blue">파랑</label> 
                            </button>
                            
                            <button onClick={()=>{this.props.setTheme("theme_green")}} aria-label='change color green'>
                                <input tabIndex={-1} type="radio" id="colorGreen" name="piece_txt" className="inp_blind" checked={this.props.theme === "theme_green"} onChange={()=>{this.props.setTheme("theme_green")}}/>
                                <label htmlFor="colorGreen" className="inp_piece color_green">초록</label>
                            </button>
                                
                            
                            <button onClick={()=>{this.props.setTheme("theme_purple")}} aria-label='change color purple'>
                                <input tabIndex={-1} type="radio" id="colorPurple" name="piece_txt" className="inp_blind" checked={this.props.theme === "theme_purple"} onChange={()=>{this.props.setTheme("theme_purple")}}/>
                                <label htmlFor="colorPurple" className="inp_piece color_purple">보라</label>
                            </button>
                            
                            <button onClick={()=>{this.props.setTheme("theme_red")}} aria-label="change color red">
                                <input tabIndex={-1} type="radio" id="colorRed" name="piece_txt" className="inp_blind"  checked={this.props.theme === "theme_red"} onChange={()=>{this.props.setTheme("theme_red")}}/>
                                <label htmlFor="colorRed" className="inp_piece color_red" >빨강</label>
                            </button>
                            
                        </div>
                    </li>
                        <li className="sub_menu_item">
                        <dl>
                            <dt tabIndex={0}>{this.props.uiTexts.text_37}</dt>
                            <dd>
                            <button
                                className="inp_radio"
                                onClick={() => this.handleChangeGptYn("Y")}
                            >
                                <input
                                tabIndex={-1}
                                type="radio"
                                name="gptYn"
                                className="inp_rdo"
                                checked={this.state.gptMode === "Y"}
                                readOnly
                                />
                                <label className="inp_label">
                                <span className="ico_comm ico_rdo"></span>  {this.props.uiTexts.text_38}
                                </label>
                            </button>

                            <button
                                className="inp_radio"
                                style={{ marginLeft: "10px" }}
                                onClick={() => this.handleChangeGptYn("N")}
                            >
                                <input
                                tabIndex={-1}
                                type="radio"
                                name="gptYn"
                                className="inp_rdo"
                                checked={this.state.gptMode  === "N"}
                                readOnly
                                />
                                <label className="inp_label">
                                <span className="ico_comm ico_rdo"></span> {this.props.uiTexts.text_39}
                                </label>
                            </button>
                            </dd>
                        </dl>
                        </li>                    </ul>

                <button type="button" className="btn_close" onClick={this.handleClickClose}><span className="ico_comm ico_close">메뉴 레이어 닫기</span></button>
            </div>
        );
    }
};

export default SideMenu;